import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    selectedClientIds: string[];
  };
}

export const setSelectedClientIdsListWithClearDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { selectedClientIds } = action.payload;

  state.selectedClientIds = selectedClientIds;
};
